import DmvsIcons from "@dmvs/api/icons";

export default [
    {
        label: "RSS kanály",
        to: "/rss",
        icon: DmvsIcons.RSS,
    },
];
